export const translations: Record<'en' | 'bn', Record<string, string>> = {
  en: {
    'app.title': 'National Land Information Service',
    'app.subtitle': 'Land Owner Certificate & Unified Land Account',
    'nav.dashboard': 'Dashboard',
    'nav.certificate': 'My Certificate',
    'nav.mylands': 'My Lands',
    'nav.services': 'Services',
    'nav.notifications': 'Notifications',
    'nav.profile': 'Profile',
    'nav.reports': 'Reports',
    'nav.logout': 'Logout',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.download': 'Download',
    'common.print': 'Print',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.submit': 'Submit',
    'common.back': 'Back',
    'common.viewDetails': 'View Details',
    'common.welcome': 'Welcome',
    'common.actionNeeded': 'Action Needed',
    'common.quickActions': 'Quick Actions',
    'common.status': 'Status',
    'common.all': 'All',
    'land.totalLands': 'Total Lands',
    'land.totalArea': 'Total Area',
    'land.districts': 'Districts',
    'land.recentLands': 'Recent Lands',
    'land.addNew': 'Add New Land',
    'land.mouza': 'Mouza',
    'land.khatian': 'Khatian',
    'land.dag': 'Dag No',
    'land.upazila': 'Upazila',
    'land.district': 'District',
    'land.type': 'Land Type',
    'land.area': 'Area',
    'land.ownership': 'Ownership',
    'land.taxStatus': 'Tax Status',
    'land.mutation': 'Mutation',
    'land.dispute': 'Dispute',
    'land.agricultural': 'Agricultural',
    'land.residential': 'Residential',
    'land.commercial': 'Commercial',
    'status.paid': 'Paid',
    'status.due': 'Due',
    'status.completed': 'Completed',
    'status.pending': 'Pending',
    'status.none': 'None',
    'status.active': 'Active',
    'dashboard.mapView': 'Map View',
    'dashboard.pendingServices': 'Pending Services',
    'certificate.title': 'Land Owner Certificate',
    'certificate.verified': 'Verified',
    'certificate.ownerName': 'Owner Name',
    'certificate.ownerId': 'Owner ID',
    'certificate.certNo': 'Certificate No.',
    'certificate.clickToView': 'Click to view full certificate',
    'mylands.title': 'My Lands',
    'mylands.subtitle': 'Manage all your registered properties',
    'mylands.searchPlaceholder': 'Search by district, mouza...',
    'mylands.addTitle': 'Add New Land Record',
    'details.title': 'Land Details',
    'details.info': 'Land Information',
    'details.history': 'Mutation History',
    'details.tax': 'Tax Payment',
    'details.services': 'Service Requests',
    'details.documents': 'Documents',
    'details.uploadDoc': 'Upload Document',
    'details.viewMap': 'View Map',
    'details.downloadRecord': 'Download Record',
    'reports.title': 'Reports & Analytics',
    'reports.subtitle': 'View your land statistics and payment history',
    'reports.taxSummary': 'Tax Payment Summary',
    'reports.landDistribution': 'Land Distribution by Type',
    'reports.generate': 'Generate Report',
    'services.title': 'Land Services',
    'services.subtitle': 'Apply for services or track existing applications',
    'notifications.title': 'Notifications',
    'notifications.subtitle': 'Stay updated with your land account activities',
    'notifications.markAllRead': 'Mark all as read',
    'profile.title': 'Profile & Settings',
    'profile.subtitle': 'Manage your personal information and account security',
    'login.title': 'Citizen Login',
    'login.subtitle': 'Secure Unified Land Account Portal',
    'login.mobile': 'Mobile',
    'login.nid': 'NID',
    'login.continue': 'Continue',
    'login.verify': 'Verify OTP',
    'landing.citizenLogin': 'Citizen Login',
    'landing.accessAccount': 'Access Unified Account',
    'landing.verifyCert': 'Verify Certificate',
  },
  bn: {
    'app.title': 'জাতীয় ভূমি তথ্য সেবা',
    'app.subtitle': 'ভূমি মালিকানা সনদ ও একীভূত ভূমি অ্যাকাউন্ট',
    'nav.dashboard': 'ড্যাশবোর্ড',
    'nav.certificate': 'আমার সনদপত্র',
    'nav.mylands': 'আমার জমি',
    'nav.services': 'সেবাসমূহ',
    'nav.notifications': 'বিজ্ঞপ্তি',
    'nav.profile': 'প্রোফাইল',
    'nav.reports': 'প্রতিবেদন',
    'nav.logout': 'লগআউট',
    'common.search': 'অনুসন্ধান',
    'common.filter': 'ফিল্টার',
    'common.download': 'ডাউনলোড',
    'common.print': 'প্রিন্ট',
    'common.save': 'সংরক্ষণ',
    'common.cancel': 'বাতিল',
    'common.submit': 'জমা দিন',
    'common.back': 'পিছনে',
    'common.viewDetails': 'বিস্তারিত দেখুন',
    'common.welcome': 'স্বাগতম',
    'common.actionNeeded': 'পদক্ষেপ প্রয়োজন',
    'common.quickActions': 'দ্রুত কার্যক্রম',
    'common.status': 'অবস্থা',
    'common.all': 'সব',
    'land.totalLands': 'মোট জমি',
    'land.totalArea': 'মোট এলাকা',
    'land.districts': 'জেলা',
    'land.recentLands': 'সাম্প্রতিক জমি',
    'land.addNew': 'নতুন জমি যোগ করুন',
    'land.mouza': 'মৌজা',
    'land.khatian': 'খতিয়ান',
    'land.dag': 'দাগ নং',
    'land.upazila': 'উপজেলা',
    'land.district': 'জেলা',
    'land.type': 'জমির ধরন',
    'land.area': 'এলাকা',
    'land.ownership': 'মালিকানা',
    'land.taxStatus': 'কর অবস্থা',
    'land.mutation': 'নামজারি',
    'land.dispute': 'বিরোধ',
    'land.agricultural': 'কৃষি',
    'land.residential': 'আবাসিক',
    'land.commercial': 'বাণিজ্যিক',
    'status.paid': 'পরিশোধিত',
    'status.due': 'বকেয়া',
    'status.completed': 'সম্পন্ন',
    'status.pending': 'বিচারাধীন',
    'status.none': 'নেই',
    'status.active': 'সক্রিয়',
    'dashboard.mapView': 'মানচিত্র দেখুন',
    'dashboard.pendingServices': 'বিচারাধীন সেবা',
    'certificate.title': 'ভূমি মালিকানা সনদ',
    'certificate.verified': 'যাচাইকৃত',
    'certificate.ownerName': 'মালিকের নাম',
    'certificate.ownerId': 'মালিক আইডি',
    'certificate.certNo': 'সনদ নং',
    'certificate.clickToView': 'সম্পূর্ণ সনদ দেখতে ক্লিক করুন',
    'mylands.title': 'আমার জমি',
    'mylands.subtitle': 'আপনার নিবন্ধিত সমস্ত সম্পত্তি পরিচালনা করুন',
    'mylands.searchPlaceholder': 'জেলা, মৌজা দ্বারা অনুসন্ধান করুন...',
    'mylands.addTitle': 'নতুন জমির রেকর্ড যোগ করুন',
    'details.title': 'জমির বিস্তারিত',
    'details.info': 'জমির তথ্য',
    'details.history': 'নামজারি ইতিহাস',
    'details.tax': 'কর প্রদান',
    'details.services': 'সেবার অনুরোধ',
    'details.documents': 'নথিপত্র',
    'details.uploadDoc': 'নথি আপলোড করুন',
    'details.viewMap': 'মানচিত্র দেখুন',
    'details.downloadRecord': 'রেকর্ড ডাউনলোড করুন',
    'reports.title': 'প্রতিবেদন ও বিশ্লেষণ',
    'reports.subtitle': 'আপনার জমির পরিসংখ্যান এবং অর্থপ্রদানের ইতিহাস দেখুন',
    'reports.taxSummary': 'কর প্রদানের সারসংক্ষেপ',
    'reports.landDistribution': 'ধরন অনুযায়ী জমি বন্টন',
    'reports.generate': 'প্রতিবেদন তৈরি করুন',
    'services.title': 'ভূমি সেবাসমূহ',
    'services.subtitle': 'সেবার জন্য আবেদন করুন বা বিদ্যমান আবেদন ট্র্যাক করুন',
    'notifications.title': 'বিজ্ঞপ্তি',
    'notifications.subtitle':
      'আপনার ভূমি অ্যাকাউন্টের কার্যক্রম সম্পর্কে আপডেট থাকুন',
    'notifications.markAllRead': 'সবগুলো পঠিত হিসেবে চিহ্নিত করুন',
    'profile.title': 'প্রোফাইল ও সেটিংস',
    'profile.subtitle':
      'আপনার ব্যক্তিগত তথ্য এবং অ্যাকাউন্ট নিরাপত্তা পরিচালনা করুন',
    'login.title': 'নাগরিক লগইন',
    'login.subtitle': 'নিরাপদ একীভূত ভূমি অ্যাকাউন্ট পোর্টাল',
    'login.mobile': 'মোবাইল',
    'login.nid': 'এনআইডি',
    'login.continue': 'চালিয়ে যান',
    'login.verify': 'ওটিপি যাচাই করুন',
    'landing.citizenLogin': 'নাগরিক লগইন',
    'landing.accessAccount': 'একীভূত অ্যাকাউন্ট অ্যাক্সেস করুন',
    'landing.verifyCert': 'সনদ যাচাই করুন',
  },
}
